import { render } from "./opportunities-list.component.vue?vue&type=template&id=7988f6e2&ts=true"
import script from "./opportunities-list.component.vue?vue&type=script&lang=ts"
export * from "./opportunities-list.component.vue?vue&type=script&lang=ts"

import "./opportunities-list.component.vue?vue&type=style&index=0&id=7988f6e2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__